
function Header() {
    
    return(
        <header className="header">
            <img className="header--image" 
                 src="./images/troll-face.png" 
                 alt="Meme troll-face" />
            <h2 className="header--title">Meme Generator</h2>
            <h4 className="header--project">React Project</h4>
        </header>
    )
}

export default Header